import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/homepage.scss';
import Card from "../models/common/Card";
import ButtonArrow from "./ButtonArrow";
import { Col, Container, Row } from "react-bootstrap";


function CardsFormatThree(props) {

    const [eyeBrownHeader] = useState(props.eyeBrownHeader);
    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [cards] = useState<Record<number, Card[]>>(props.cards);
    const [addClass] = useState(props.addClass);

    function createRows() {
        let htmlList: JSX.Element[] = [];
        for (const key in cards) {
            console.log(cards[key]);
            htmlList[key] = fillRow(cards[key]);
        }
        return htmlList;
    }

    function fillRow(cardsList: Card[]) {
        return <Row className={cardsList.length === 1 ? "justify-content-center" : ""}>
            {cardsList.map((c,i) =>
                <Col xs={12} sm={12} md={12} className={"cardSectionHomepage" + ((i===2) ? " removeMarginRight" : "")}>
                    <img src={c.image} alt='...'  />
                    {addTittle(c)}
                    {c.subTitle && !c.linkToRedirect ? addSubTitle(c.subTitle) : ""}
                    {c.htmlCode && !c.linkToRedirect ? addSubTitle(c.htmlCode) : ""}
                    {c.linkToRedirect ? <ButtonArrow link={c.linkToRedirect} buttonName={c.subTitle} width="15%" /> : ""}
                </Col>)}

        </Row>
    }

    function addSubTitle(subTitle: string | JSX.Element) {
        return <div className="d-flex align-items-start justify-content-center align-self-stretch howSubSection pl-4 pr-4">{subTitle}</div>;
    }

    function addTittle(card: Card) {
        return card.title === "" ? "" : <div className="cardTitle textAllign mt-2 mb-2">{card.title}</div>;
    }


    return (

        <div>
            <div className="mb-5">
                <div className="benefLetterSection">
                    <div className="benefEyebrowHeader">
                        {eyeBrownHeader}
                    </div>
                    <div>{title}</div>
                    <div className="mt-3 benefHeaderTwo">
                        {subTitle}
                    </div>
                </div>
            </div>

            <Container className={addClass} >
                {createRows()}
            </Container>
        </div>

    )


}

export default withRouter(CardsFormatThree);



